import 'whatwg-fetch'
// TODO: set up production route
const url =
  process.env.NODE_ENV === 'production'
    ? 'https://roosterreminders.com:3001/api/v1/bookings'
    : 'http://localhost:3001/api/v1/bookings'

const eventUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://roosterreminders.com:3001/api/v1/interaction_events'
    : 'http://localhost:3001/api/v1/interaction_events'

const headers = {
  Accept: 'application/json',
}

export function getBookings(start, end, key) {
  // e.g. start=01-01-2017&end=01-01-2018
  if (key) {
    headers.Authorization = key
  }
  if (!headers.Authorization) {
    return Promise.reject(new Error('no token present'))
  }
  return fetch(
    `${url}?consumer=widget&start=${start.format(
      'DD-MM-YYYY',
    )}&end=${end.format('DD-MM-YYYY')}`,
    { headers },
  ).then(res => {
    const data = res.json()
    if (res.ok) {
      return data
    }
    return Promise.reject(
      JSON.stringify({
        status: res.status,
        data,
        token: headers.Authorization,
      }),
    )
  })
}

export function putBooking(bookingId, status) {
  return fetch(`${url}/${bookingId}`, {
    method: 'PUT',
    body: JSON.stringify({ status }),
    headers,
  }).then(res => {
    const data = res.json()
    if (res.ok) {
      return data
    }
    return Promise.reject(JSON.stringify({ status: res.status, data }))
  })
}


export function postAppointment(body) {
  return fetch(`${url}/booking_success`, {
    method: 'POST',
    body,
    headers,
  }).then(res => {
    const data = res.json()
    if (res.ok) {
      return data
    }
    return Promise.reject(JSON.stringify({ status: res.status, data }))
  })
}

const eventHeader = {
  'Content-Type': 'application/json',
};

export function postEvent(body) {
  eventHeader.Authorization = headers.Authorization;
  return fetch(eventUrl, {
    method: 'POST',
    body,
    headers: eventHeader,
  })
    .then(res => res.json())
    .then(res => res);
}



// WEBPACK FOOTER //
// ./src/helpers/dataHelpers.js